import Hero from "../Hero/Hero";
import Skills from "../Skills/Skills";
import QuoteSection from "../QuoteSection/QuoteSection";
import ChefsSection from "../ChefsSection/ChefsSection";
function Home() {
  return (
    <div>
      <Hero />
      <Skills />
      <QuoteSection />
      <ChefsSection />
    </div>
  );
}

export default Home;
